import { render } from "./AlarmNewView.vue?vue&type=template&id=0d62bdd8"
import script from "./AlarmNewView.vue?vue&type=script&lang=js"
export * from "./AlarmNewView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__